module.exports = __webpack_public_path__ + "assets/img/enterIcon4.a23cb187.png";